import { buttonVariants } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@arcadeai/design-system/components/ui/atoms/card";
import { cn } from "@arcadeai/design-system/lib/utils";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useGetTools } from "../../tools/api/hooks";
import { columns } from "../../tools/data-table/columns";
import { ToolsTable } from "../../tools/data-table/tools-table";

export function ToolsWidget() {
  const { data: tools } = useGetTools();

  return (
    <div className="grid grid-cols-1">
      <Card className="gap-2">
        <CardHeader className="mt-1 flex flex-row justify-between pb-2">
          <div className="flex flex-col gap-2">
            <CardTitle className="text-xl">Tools</CardTitle>
            <CardDescription>{tools.items.length} tools</CardDescription>
          </div>
          <Link
            className={cn(buttonVariants({ variant: "secondary", size: "sm" }))}
            from="/orgs/$organizationId/projects/$projectId/tools"
            to="."
          >
            View all
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </CardHeader>
        <CardContent>
          <ToolsTable
            columns={columns}
            data={tools.items}
            defaultPageSize={5}
            stickyColumnBg="card"
          />
        </CardContent>
      </Card>
    </div>
  );
}
